<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <main-nav />
    </transition>
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <div
        v-if="protectedRouteInvalid"
        class="no-company-warning notification is-warning has-text-centered"
      >
        <b-icon icon="alert-circle-outline" />
        Your account isn't linked with any companies. Contact your admin for a new invitation link.
      </div>
    </transition>
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <router-view v-if="!companyRouteInvalid" />
    </transition>

    <!-- Owner Portal Popup -->
    <div
      v-if="showOwnerPortalPopup"
      class="modal is-active"
    >
      <div
        class="modal-background"
        @click="dismissPopup"
      />
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Notice
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="dismissPopup"
          />
        </header>
        <section class="modal-card-body">
          <p>{{ ownerPortalPopupText }}</p>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            @click="dismissPopup"
          >
            Close
          </button>
          <a
            v-if="ownerPortalPopupLink"
            :href="ownerPortalPopupLink"
            target="_blank"
            rel="noopener noreferrer"
            class="button is-primary"
            @click="dismissPopup"
          >
            Learn More
          </a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainNav from './components/MainNav.vue'

export default {
  name: 'App',

  components: { MainNav },

  data () {
    return { popupDismissed: false }
  },

  computed: {
    ...mapGetters([
      'hasCompany',
      'protectedRouteInvalid',
      'companyRouteInvalid',
      'showRouteNav',
      'activeCompany'
    ]),

    ownerPortalPopupConfig () {
      return this.activeCompany?.owner_portal_popup
    },

    ownerPortalPopupEnabled () {
      return this.ownerPortalPopupConfig?.enabled === true
    },

    ownerPortalPopupText () {
      return this.ownerPortalPopupConfig?.text ?? ''
    },

    ownerPortalPopupLink () {
      return this.ownerPortalPopupConfig?.link ?? null
    },

    showOwnerPortalPopup () {
      return Boolean(this.hasCompany) &&
        this.ownerPortalPopupEnabled === true &&
        this.popupDismissed === false
    }
  },

  methods: {
    dismissPopup () {
      this.popupDismissed = true
    }
  }
}
</script>

<style src="./assets/styles/index.sass" lang="sass"></style>
